export class MoneyFunction {

    static decimalPoint = '.';
    static moneySymbol = '$';
    static symbolPosition = 'before';
    static groupingSeparator = ',';
    static groupingSize = 3;
    static arbotypePage = 'cerfa';
    static newSimulatorUrl = '';

    static setRegionalSettings(settings) {
        MoneyFunction.decimalPoint = settings.decimalPoint;
        MoneyFunction.moneySymbol = settings.moneySymbol;
        MoneyFunction.symbolPosition = settings.symbolPosition;
        MoneyFunction.arbotypePage = settings.arbotypePage;
        MoneyFunction.newSimulatorUrl = settings.newSimulatorUrl;
        MoneyFunction.groupingSeparator = settings.groupingSeparator;
        MoneyFunction.groupingSize = settings.groupingSize;
    }

}
